const CLICK = 'click';
const IMPRESSION = 'impression';

export const COMING_SOON_MODAL_IMPRESSION = {
  eid: 'coming_soon_modal.impression',
  type: IMPRESSION
};

export const PRODUCT_DETAIL_PAGE_ADD_TO_CART_CTA_CLICK = {
  eid: 'product_detail_page.add_to_cart_cta.click',
  type: CLICK
};

export const OLS_CART_VIEW = ({ loggedIn, cartSize }) => {
  return {
    eid: 'OLS.CART_VIEW',
    type: CLICK,
    params: [['Logged in', loggedIn], ['Cart size', cartSize]]
  };
};

export const OLS_CART_REMOVEITEM = ({ productType, beginningCartSize }) => {
  return {
    eid: 'OLS.CART_REMOVEITEM',
    type: CLICK,
    params: [['Product type', productType], ['Beginning cart size', beginningCartSize]]
  };
};

export const OLS_CART_ADJUST_ITEM_QTY = ({ adjustedQty, beginningQty }) => {
  return {
    eid: 'OLS.CART_ADJUST_ITEM_QTY',
    type: CLICK,
    params: [['Adjusted Qty', adjustedQty], ['Beginning Qty', beginningQty]]
  };
};

export const OLS_CART_UPDATE = {
  eid: 'OLS.CART_UPDATE',
  type: CLICK
};

export const OLS_CART_APPLYCOUPON = ({ valid }) => {
  return {
    eid: 'OLS.CART_APPLYCOUPON',
    type: CLICK,
    params: [['Valid', valid]]
  };
};

export const OLS_CART_CONTINUE_SHOPPING = ({ beginningCartSize }) => {
  return {
    eid: 'OLS.CART_CONTINUE_SHOPPING',
    type: CLICK,
    params: [['Beginning cart size', beginningCartSize]]
  };
};
